import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/CaretDown.svg'

export const IconCaretDown = IconSVG as IconComponent
